import Styled from 'styled-components';


export const Container = Styled.div`
margin-top: 20px;
margin: 0 7%;
margin-bottom: 70px;

.escolha{
    font-size: 1.2rem;
    font-weight: bold;
}

@media(max-width: 800px) {
  margin: 0 2%;
}
`

/* Desktop: coluna central de 720px (igual aos menus) */
export const PageWrap = Styled.div`
  @media (min-width: 1024px) {
    .container { max-width: 720px; }
  }
`

export const Tag = Styled.div`
  display: inline-block;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  border: 1px solid transparent;
  color: white;
  background-color: ${props => props.theme.primary};
  border-radius: 9px;
  width: 33%;
  height: 22px;
  font-weight: normal;
`

export const Total = Styled.div`
  display: flex;
  margin: 20px 0;
  font-weight: bold;
  font-size: 0.9rem;
  color: black;
  gap: 14px;
  flex-direction: column;
  p{
    margin-top: 1rem;
    font-size:18px;
  }
`

export const Travel = Styled.div`
  display: grid;
  grid-template-columns: auto auto;
`

export const H3 = Styled.h3`
font-style: normal;
font-weight: 600;
font-size: 20px;
line-height: 120%;
letter-spacing: -0.02em;
font-feature-settings: 'pnum' on, 'lnum' on;
padding-top: 20px;
`

export const AccordionContent = Styled.div`
margin: 0 7%;
 
.css-o4b71y-MuiAccordionSummary-content{
  margin: 0px !important;
  padding: 0px !important;
}

svg{

}

.title{
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  color: ${props => props.theme.primary};
}

cursor:pointer;


 svg{
  float: right;
  height: 18px;
 } 

@media(max-width: 800px) {
  margin: 0;
}
`



export const AccordionRequest = Styled.div`
margin: 0 7%;
margin-top: 20px;
 
  svg{

 }
 
 .title{
   color: black !important;
   font-size: 1.1rem !important;
   font-weight: bold;
   
 }
 
 cursor:pointer;
 
 
  svg{
   float: right;
   height: 18px;
  } 
 
 .css-sh22l5-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded{
     min-height: 48px;
     
 }
 .css-15v22id-MuiAccordionDetails-root {
    padding: 0px !important;
 }

 
 @media(max-width: 800px) {
   margin: 0;
   margin-top: 20px;
 }

`
export const Content = Styled.div`
display: flex;
flex-direction: column;
margin-bottom:20px;
.description{
  font-size: 0.9rem;
}
.total{
  margin-top: 20px;
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 0.9rem;
  color: black;
}

`
export const Line = Styled.div`
  border: 1px solid #d7d7db;
  width: 100%;
`

export const ProductItem = Styled.p`
line-break: auto;
color: #696969;
`

export const SubProductItem = Styled.span`
color: #696969;
`

export const Value = Styled.span`
font-weight: 700;
font-size: 16px;
line-height: 150%;
color: ${props => props.theme.primary};

`

export const Title = Styled.h3`
color: var(--primary-color);
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 120%;
letter-spacing: 0.04em;
margin-bottom: 8px;
`

export const Bold = Styled.p`
display:flex;
align-items: center;
justify-content: space-between;
font-weight: 600;
font-size: 18px;
line-height: 150%;
color: ${props => props.theme.primary};
`

export const PaymentInformation = Styled.div`
padding: 0px;
`

export const ItemInformation = Styled.div`
padding: 0px;
margin-top: 20px;
font-size: 18px;
 span{
  font-size: 16px;
 }
`

export const DescriptionOrder = Styled.p`
margin-top: -10px;
font-size: 0.9rem;
color: ${props => props.theme.primary};
`
export const CardData = Styled.ul`
list-style-type : none;
padding-left: 0px !important;
color: #696969;
`

export const CardDataItem = Styled.li`
font-style: normal;
font-weight: 400;
font-size: 15px;
line-height: 145%;
letter-spacing: -0.01em;
`

export const Block = Styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: 15px;
  div{
    gap: 12px;
    display: flex;
    flex-direction: column;
  }
`

export const FlexRow = Styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
  p {
    font-weight: 600;
    font-size: 18px;
    line-height: 150%;
    color: var(--text-dark)
  }
`;